/** 后台会话失效时展示的统一、可操作提示。 */
export const SESSION_EXPIRED_MESSAGE = '登录已超时，请重新登录';

/**
 * 只依据标准 HTTP 状态判断身份是否失效。
 *
 * 403 表示已经识别身份但没有权限，网络异常则没有响应状态；
 * 两者都不能清除用户的有效登录状态。
 */
export function isUnauthorizedError(error) {
  return Number(error && error.response && error.response.status) === 401;
}

/**
 * 创建一次性的后台会话失效处理器。
 *
 * 依赖由调用方注入，使本模块不依赖 Vue、Axios 或浏览器存储实现，
 * 同时便于精确测试清理、提示和跳转的执行次数。
 */
export function createSessionExpiryHandler(dependencies) {
  // 页面可能并发加载多个接口；首个 401 已经足以确认当前会话不可用。
  let handled = false;

  return function handleSessionExpiry(error) {
    // 非 401 继续交给原有 HTTP 错误策略处理。
    if (!isUnauthorizedError(error)) {
      return false;
    }

    // 每个失败请求仍会被上层 reject，但全局副作用只能执行一次。
    if (handled) {
      return true;
    }
    handled = true;

    // 先清除旧标记，防止路由继续把失效会话视为已登录。
    dependencies.clearSession();
    dependencies.notify(SESSION_EXPIRED_MESSAGE);

    // 登录页本身不重复导航，避免无意义的路由事件。
    if (!dependencies.isLoginRoute()) {
      dependencies.redirectToLogin();
    }

    return true;
  };
}
